import { ComponentProps, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface CardInputsContainerProps extends Omit<
  ComponentProps<"div">,
  "title"
> {
  actions?: ReactNode;
  title: ReactNode;
  titleClassName?: string;
  containerClassName?: string;
  contentClassName?: string;
}

export const CardInputsContainer = ({
  children,
  actions,
  title,
  className,
  titleClassName,
  containerClassName,
  contentClassName,
}: CardInputsContainerProps) => {
  return (
    <div
      className={twMerge(
        "flex w-full flex-col gap-4 rounded-xl border md:max-w-[49rem]",
        className,
      )}
    >
      <div
        className={twMerge(
          "flex flex-col items-start justify-between gap-2 rounded-t-xl border-b bg-primary-20 p-3 px-5 text-base sm:flex-row sm:items-center",
          containerClassName,
        )}
      >
        <div className={titleClassName}>{title}</div>
        {actions && <div className="flex">{actions}</div>}
      </div>
      <div className={twMerge("px-5 pb-3 pt-0", contentClassName)}>
        {children}
      </div>
    </div>
  );
};
